import { type HighlightMaterial } from '@meitu/saas-editor-core/es/framework/services/text-highlight';

export const getHighlightThumbnailURL = (highlight: HighlightMaterial, theme: string, isIntl: boolean) => {
    const fallback = highlight.thumbnail?.url || '';

    if (isIntl) {
        return highlight.thumbnailBlack?.url || fallback; // 海外不支持切换主题，所以用默认黑色底缩略图
    }
    // light 模式用黑色底缩略图
    return (theme === 'light' ? highlight.thumbnailBlack?.url : highlight.thumbnail?.url) || fallback;
};
